<template>
  <div
    class="featured-articles"
    v-if="isMqMedium && hasArticles"
    v-data-test-id="'featured-articles'"
  >
    <div class="featured-articles__top-block">
      <div class="featured-articles__title" v-data-test-id="'featured-articles-title'">
        {{ featuredArticles.title }}
      </div>
      <a
        v-if="allArticlesHref"
        :href="allArticlesHref"
        class="featured-articles__see-all"
        data-test-id="featured-articles-href"
        >{{ $t('filter.featured_articles.see_all') }}
        <span class="featured-articles__see-all-icon icon-chevron"></span>
      </a>
    </div>
    <div class="featured-articles__articles-container">
      <a
        v-for="(article, index) in articles"
        class="featured-articles__article"
        :href="article.articleUrl"
        :key="index"
      >
        <ImageContentful
          :src="article.thumbUrl"
          containerSelector=".featured-articles__image"
          :options="{ imageCompression: 71, setHeight: false }"
          :isBackgroundImage="true"
          class="featured-articles__image"
        />
        <div
          class="featured-articles__description"
          v-data-test-id="'featured-articles-description'"
        >
          {{ article.title }}
          <span class="featured-articles__description-icon icon-chevron"></span>
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { ARTICLES_CATEGORY_PATH } from '@/config/constants'
import { formatPathWithId } from '@/helpers/url'
import ImageContentful from '@/components/_shared/ImageContentful.vue'

export default {
  name: 'FeaturedArticles',
  components: { ImageContentful },
  props: {
    featuredArticles: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      isMqCinema: 'viewport/isMqCinema',
      isMqFull: 'viewport/isMqFull',
      isMqMedium: 'viewport/isMqMedium',
      getFullUrl: 'page/getFullUrl',
    }),

    articles() {
      const articleCount = this.isMqCinema ? 4 : this.isMqFull ? 3 : this.isMqMedium ? 2 : 1
      return this.featuredArticles.articles.slice(0, articleCount)
    },

    allArticlesHref() {
      return this.featuredArticles.categoryLink
        ? this.getFullUrl(
            formatPathWithId(ARTICLES_CATEGORY_PATH, this.featuredArticles.categoryLink)
          )
        : null
    },

    hasArticles() {
      return this.featuredArticles?.articles?.length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
@import './FeaturedArticles';
</style>
